export const baseUrlDev = "https://planetdigital.xtim.tv/api/";
export const baseUrlProd = "https://planetdigital.xtim.tv/api/";
export const providerName = "https://arenaxui.fastcloudnetwork.com:25463";
export const reskinName = "planetDigital";
export const demo = false;
